"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5665],{

/***/ 95665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 2.19998C12.6 2.19998 16.4 5.09998 20.2 5.99998C20.7 6.09998 21 6.49998 21 6.99998V11C21 18.6 12.7 21.8 12.4 21.9C12.2 22 12.1 22 12 22C11.9 22 11.8 22 11.6 21.9C11.3 21.8 3 18.6 3 11V6.99998C3 6.49998 3.3 6.09998 3.8 5.99998C7.5 5.09998 11.4 2.19998 11.4 2.19998C11.8 1.89998 12.2 1.89998 12.6 2.19998ZM12 19.9C13.5 19.3 19 16.4 19 11V7.79998C16 6.89998 13.2 5.09998 12 4.29998C10.8 5.09998 8 6.89998 5 7.79998V11C5 16.4 10.5 19.3 12 19.9ZM8.3 11.3C8.7 10.9 9.3 10.9 9.7 11.3L11 12.6L14.3 9.3C14.7 8.9 15.3 8.9 15.7 9.3C16.1 9.7 16.1 10.3 15.7 10.7L11.7 14.7C11.5 14.9 11.3 15 11 15C10.7 15 10.5 14.9 10.3 14.7L8.3 12.7C7.9 12.3 7.9 11.7 8.3 11.3Z"
}), "Safety"));


/***/ })

}]);